const bfSizeChartCustomDisplay = () => {
  const interval = setInterval(() => {
    const bfSizeChart = document.querySelector('.page-content--product .best-fit-size-chart');
    const sizeLabel = document.querySelector('.page-content--product .swatch-label:has(input[name="Size"])');

    if(bfSizeChart && sizeLabel) {
      sizeLabel.appendChild(bfSizeChart);
      clearInterval(interval);
    }
  }, 300);
}

window.addEventListener('DOMContentLoaded', bfSizeChartCustomDisplay);